import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=7dd97b32&"
import script from "./Electricity.vue?vue&type=script&lang=js&"
export * from "./Electricity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports